import { type FC, type ReactNode } from 'react';

// MUI
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface StyledAccordionProps {
  children: ReactNode;
  label: string;
  isDefaultExpanded?: boolean;
}

const StyledAccordion: FC<StyledAccordionProps> = (props) => {
  const { children, label, isDefaultExpanded = false } = props;

  return (
    <Accordion
      defaultExpanded={isDefaultExpanded}
      sx={{
        border: '1px solid #D6D6D6',
        borderRadius: '12px',
        boxShadow: '2px 2px 6px #D6D6D6',
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default StyledAccordion;
